import React from "react";
import { Box } from "@mui/material";
import AdminSideNav from "../../../adminComponents/sidenav";
import AdminHeader from "../../../adminComponents/header";
import ClientDetailedLogs from "./ClientDetailedLogs";

const ClientLogsIndex = () => {
  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          ml: { xs: "0px", md: "200px" },
        }}
      >
        <AdminSideNav />
        <Box
          sx={{
            display: {
              xs: "none",
              md: "initial",
            },
          }}
        >
          <AdminHeader title={"Client Bifurcation"} />
        </Box>
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: { xs: 2, md: 3 }
          }}
        >
          <ClientDetailedLogs />
        </Box>
      </Box>
    </Box>
  );
};

export default ClientLogsIndex;
